

// Si l'utilisateur a la méthode "Exercice", on affiche un menu différent
const storedUser = sessionStorage.getItem("authUser");
const authUser = storedUser ? JSON.parse(storedUser) : null;



let MenuList = [
     {
            title: 'ACCUEIL',
            iconStyle: <i className="flaticon-381-home" />,
            to: 'dashboard',
        },
        {
            title: 'DIET',
            classsChange: 'mm-collapse',
            iconStyle: <i className="flaticon-381-focus" />,
            content: [
                { title: 'Recettes', to: 'diet-food-recette' },
                { title: 'Daily Plan', to: 'dailyPlan' },
                { title: 'Diet plan', to: 'diet-plan' },
                { title: 'History', to: 'history' },
            ],
        },
        {
            title: 'EXERCICES',
            classsChange: 'mm-collapse',
            iconStyle: <i className="flaticon-381-broken-heart" />,
            content: [
                { title: 'Workout plan', to: 'wokoutPlan' },
                { title: 'Mes exercices', to: 'workout' },
            ],
        },
        {
            title: 'COMMUNAUTES',
            classsChange: 'mm-collapse',
            iconStyle: <i className="flaticon-381-perspective" />,
        },
        {
            title: 'BLOG',
            iconStyle: <i className="flaticon-381-speaker" />,
            to: 'blog',
        },
        {
            title: 'APPS',
            classsChange: 'mm-collapse',
            iconStyle: <i className="flaticon-381-smartphone" />,
            content: [
                { title: 'IOS', to: 'page-error-404' },
                { title: 'Android', to: 'page-error-404' },
            ],
        },
        {
            title: 'PREMIUM',
            iconStyle: <i className="flaticon-381-diamond" />,
            to: 'page-error-404',
        },
];

// if (authUser?.data.data.method === "EXERCISE") {



    
//     MenuList = [
//         {
//             title: 'ACCUEIL',
//             iconStyle: <i className="flaticon-381-home" />,
//             to: 'dashboard',
//         },
//         // {
//         //     title: 'DIET',
//         //     classsChange: 'mm-collapse',
//         //     iconStyle: <i className="flaticon-381-focus" />,
//         //     content: [
//         //         { title: 'Recettes', to: 'diet-food-recette' },
//         //         { title: 'Diet plan', to: 'diet-plan' },
//         //     ],
//         // },
//         {
//             title: 'EXERCICES',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-broken-heart" />,
//             content: [
//                 { title: 'Workout plan', to: 'wokoutPlan' },
//                 { title: 'sport categories', to: 'workout' },
//                 // { title: 'sport categories', to: 'sport-categories' },
//             ],
//         },
//         {
//             title: 'COMMUNAUTES',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-perspective" />,
//         },
//         {
//             title: 'BLOG',
//             iconStyle: <i className="flaticon-381-speaker" />,
//             to: 'blog',
//         },
//         {
//             title: 'APPS',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-smartphone" />,
//             content: [
//                 { title: 'IOS', to: 'page-error-404' },
//                 { title: 'Android', to: 'page-error-404' },
//             ],
//         },
//         {
//             title: 'PREMIUM',
//             iconStyle: <i className="flaticon-381-diamond" />,
//             to: 'page-error-404',
//         },
//     ];
// } else if (authUser?.data.data.method === "DIET") {
//     MenuList = [
//         {
//             title: 'ACCUEIL',
//             iconStyle: <i className="flaticon-381-home" />,
//             to: 'dashboard',
//         },
//         {
//             title: 'DIET',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-focus" />,
//             content: [
//                 { title: 'Recettes', to: 'diet-food-recette' },
//                 { title: 'Diet plan', to: 'diet-plan' },
//             ],
//         },
        
//         {
//             title: 'COMMUNAUTES',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-perspective" />,
//         },
//         {
//             title: 'BLOG',
//             iconStyle: <i className="flaticon-381-speaker" />,
//             to: 'blog',
//         },
//         {
//             title: 'APPS',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-smartphone" />,
//             content: [
//                 { title: 'IOS', to: 'page-error-404' },
//                 { title: 'Android', to: 'page-error-404' },
//             ],
//         },
//         {
//             title: 'PREMIUM',
//             iconStyle: <i className="flaticon-381-diamond" />,
//             to: 'page-error-404',
//         },
//     ];
// } else if (authUser?.data.data.method === "COMBINATION") {
//     MenuList = [
//         {
//             title: 'ACCUEIL',
//             iconStyle: <i className="flaticon-381-home" />,
//             to: 'dashboard',
//         },
//         {
//             title: 'DIET',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-focus" />,
//             content: [
//                 { title: 'Recettes', to: 'diet-food-recette' },
//                 { title: 'Diet plan', to: 'diet-plan' },
//             ],
//         },
//         {
//             title: 'EXERCICES',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-broken-heart" />,
//             content: [
//                 { title: 'Workout plan', to: 'wokoutPlan' },
//                 { title: 'Mes exercices', to: 'workout' },
//             ],
//         },
//         {
//             title: 'COMMUNAUTES',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-perspective" />,
//         },
//         {
//             title: 'BLOG',
//             iconStyle: <i className="flaticon-381-speaker" />,
//             to: 'blog',
//         },
//         {
//             title: 'APPS',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-smartphone" />,
//             content: [
//                 { title: 'IOS', to: 'page-error-404' },
//                 { title: 'Android', to: 'page-error-404' },
//             ],
//         },
//         {
//             title: 'PREMIUM',
//             iconStyle: <i className="flaticon-381-diamond" />,
//             to: 'page-error-404',
//         },
//     ];
// } else {
//     MenuList = [
//         {
//             title: 'ACCUEIL',
//             iconStyle: <i className="flaticon-381-home" />,
//             to: 'dashboard',
//         },
//         // {
//         //     title: 'DIET',
//         //     classsChange: 'mm-collapse',
//         //     iconStyle: <i className="flaticon-381-focus" />,
//         //     content: [
//         //         { title: 'Recettes', to: 'diet-food-recette' },
//         //         { title: 'Diet plan', to: 'diet-plan' },
//         //     ],
//         // },
//         {
//             title: 'EXERCICES',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-broken-heart" />,
//             content: [
//                 { title: 'Workout plan', to: 'wokoutPlan' },
//                 { title: 'Mes exercices', to: 'workout' },
//             ],
//         },
//         {
//             title: 'COMMUNAUTES',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-perspective" />,
//         },
//         {
//             title: 'BLOG',
//             iconStyle: <i className="flaticon-381-speaker" />,
//             to: 'blog',
//         },
//         {
//             title: 'APPS',
//             classsChange: 'mm-collapse',
//             iconStyle: <i className="flaticon-381-smartphone" />,
//             content: [
//                 { title: 'IOS', to: 'page-error-404' },
//                 { title: 'Android', to: 'page-error-404' },
//             ],
//         },
//         {
//             title: 'PREMIUM',
//             iconStyle: <i className="flaticon-381-diamond" />,
//             to: 'page-error-404',
//         },
//     ];
 //}

export { MenuList };